import React from "react";
import "../theme/privuTheme.css";
import { PRIVU_THEME, THEME_MODES } from "../theme/privuTheme";

/**
 * Applies the active design theme by setting `data-theme` / `data-mode` on a
 * wrapper element. The palette itself lives in theme/privuTheme.css as CSS
 * custom properties, so components reference tokens (var(--privu-*)).
 *
 * Usage:
 *   <TokenProvider value={{ theme: "PrivuBase", mode: "light" }}>
 */
const TokenProvider = ({ children, value = {}, ...rest }) => {
  const { theme = PRIVU_THEME, mode = "light" } = value;

  const resolvedTheme = theme || PRIVU_THEME;
  const resolvedMode = THEME_MODES.includes(mode) ? mode : "light";

  return (
    <div
      data-theme={resolvedTheme}
      data-mode={resolvedMode}
      className="privu-theme-root"
      {...rest}
    >
      {children}
    </div>
  );
};

export default TokenProvider;
